import Image from 'gatsby-image';
import React from "react";
import { HeroImage, HeroText, ImageHeroWrapper } from '../../styles/shared';
import { H2 } from '../grid/typography.component';
import Header from '../header/header';

class HeroComponent extends React.Component {
  render() {

    return (

      <ImageHeroWrapper className="image-hero-wrapper">
        <div className="clipper">
          <Header color="#fff" />
        </div>
        <HeroText>
          <H2>{this.props.title}</H2>
        </HeroText>
        <HeroImage>
          <Image fluid={this.props.image.localFile.childImageSharp.fluid} />
        </HeroImage>
      </ImageHeroWrapper>

    )
  }
}
export default HeroComponent

